/** @jsx $jsx */
import { $jsx } from 'framework7';

function framework7Component(props, _ref) {
  var $ = _ref.$,
      $f7 = _ref.$f7,
      $on = _ref.$on,
      $update = _ref.$update;
  var month = null;
  var day = null;

  window.mobileCheck = function () {
    var check = false;

    (function (a) {
      if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);

    return check;
  };

  var openAccount = function openAccount() {
    $f7.tab.show("#view-account");
  }; // $f7.request(
  // {
  //   method: 'get',
  //   url:  'https://api.bnm.gov.my/public/usd-interbank-intraday-rate', 
  //   headers: {
  //       'Accept':'application/vnd.BNM.API.v1+json',
  //       'Access-Control-Allow-Origin': 'https://apikijangportal.bnm.gov.my'
  //   },
  //   type: 'get',
  //   dataType: 'jsonp',
  //   success: function (data) 
  //   {
  //     console.log(data);
  //   }
  // });


  var angryFlush = function angryFlush(flush_type) {
    $f7.dialog.prompt('Enter phone to continue?', function (phone) {
      if (localStorage.getItem("Phone") == phone) {
        $f7.request({
          method: 'get',
          url: window.path + 'static/api/bridge.php?action=set&angry=-1&value=' + flush_type,
          success: function success(data) {
            if (flush_type == "1") $f7.dialog.alert('You have flushed and BUY');
            if (flush_type == "2") $f7.dialog.alert('You have flushed and SELL');
            if (flush_type == "3") $f7.dialog.alert('You stop trade and save emo');
            if (flush_type == "4") $f7.dialog.alert('You continue trade with saved emo');
          }
        });
      } else {
        $f7.dialog.alert("Please try again...");
      }
    });
  };

  var checkFinancial = function checkFinancial() {
    $f7.request({
      method: 'get',
      url: window.path + 'static/api/ledgerV2.php?action=get&AccountNumber=' + localStorage.getItem("AccountNumber") + "&Email=" + localStorage.getItem("Email"),
      success: function success(data) {
        //console.log("OutputFinance:" + data);
        if (data == "null") return;
        data = JSON.parse(data);
        var financialCard = "";
        $(".AccountBalanceOwn").html("US$" + data.own_lot_price);
        $(".balance-myr").html("MYR$" + (parseFloat(data.own_lot_price) * window.rate).toFixed(2));
        $(".financial-lot").html(data.own_lot + " Lot");
        $(".AccountMarketPrice").html(data.stock_price);
        localStorage.setItem("account-stock-price", data.stock_price);
        localStorage.setItem("account-own-lots", data.own_lot);
        $(".AccountLots").html(data.own_lot + " Lots");
        $(".AccountNumber").html(parseInt(localStorage.getItem("AccountNumber")) * 5);
      }
    });
  };

  var checkInfo = function checkInfo() {
    //console.log("Check" + localStorage.getItem('AccountNumber'));
    if (localStorage.getItem('AccountNumber') == null) {
      return;
    }

    $f7.request({
      method: 'get',
      url: window.path + 'static/api/info.php?action=get&AccountNumber=' + localStorage.getItem('AccountNumber'),
      success: function success(data) {
        $f7.preloader.hide(); //console.log("Output:" + data);

        data = JSON.parse(data);
        window.balance = data.account_balance;
        $('.balance').html("US$" + parseFloat(data.account_balance).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')); //$('.balance-myr').html("RM" + (parseFloat(data.account_balance ) * 4.64).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,'));

        $('.OrderPrice').html(parseFloat(data.OrderPrice).toFixed(2));
        $('.AccountMargin').html("US$" + parseFloat(data.AccountMargin).toFixed(2));
        $('.AccountFreeMargin').html("US$" + parseFloat(data.AccountFreeMargin).toFixed(2));
        $('.AccountBalance').html("US$" + parseFloat(data.account_balance).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,'));
        $(".AccountBalanceMyr").html("MYR$" + (parseFloat(data.account_balance) * data.CurrencyConversion).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,'));
        $(".CurrencyConversion").html("x " + data.CurrencyConversion);
        localStorage.setItem("account-balance", data.account_balance);
        $('.AccountName').html(data.AccountName);
        localStorage.setItem("account-name", data.AccountName);
        $('.price').html(parseFloat(data.Bid).toFixed(4));
        $('.last_refresh').html(data.datetime);
        var angryman = parseFloat(data.AccountMargin) / parseFloat(data.AccountEquity) * 100;
        $f7.progressbar.set('.angryman', angryman);
        window.rate = data.CurrencyConversion;

        if (angryman < 30) {
          $(".angryman").removeClass("color-orange");
          $(".angryman").removeClass("color-red");
          $(".angryman").addClass("color-green");
        }

        if (angryman >= 30 && angryman < 60) {
          $(".angryman").removeClass("color-green");
          $(".angryman").removeClass("color-red");
          $(".angryman").addClass("color-orange");
        }

        if (angryman >= 60) {
          $(".angryman").removeClass("color-orange");
          $(".angryman").removeClass("color-green");
          $(".angryman").addClass("color-red");
        }

        $('.angryman-percent').html(angryman.toFixed(0) + "%");
        var total_pip = 0.0;

        if (data.OrderType2 == 0) {
          $('.OrderType').html("<span style='color:#508AFF'><b>BUY</b></span");
          $('.Pip').html(parseInt((data.Bid - data.OrderPrice) / 0.1) + " Pip");
          total_pip = parseInt((data.Bid - data.OrderPrice) / 0.1);
        } else {
          $('.OrderType').html("<span style='color:#FF3737'><b>SELL</b></span");
          $('.Pip').html(parseInt((data.OrderPrice - data.Bid) / 0.1) + " Pip");
          total_pip = parseInt((data.OrderPrice - data.Bid) / 0.1);
        }

        if (data.OrderPrice == 0) {
          $('.Pip').html("0 Pip");
        }

        if (parseFloat(data.OrderProfit) > 0) {
          $('.OrderProfit').html("<span style='color:#508AFF'><b> US$" + parseFloat(data.OrderProfit).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') + "</b></span");
        } else {
          $('.OrderProfit').html("<span style='color:#FF3737'><b> US$" + parseFloat(data.OrderProfit).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') + "</b></span");
        }

        $('.OrderLots').html("" + parseFloat(data.OrderLots).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,'));
        var maxlots = parseFloat(data.MaxLots); //var angryman = parseFloat(data.OrderLots) / maxlots * 100;
        //$f7.progressbar.set('.angryman', angryman);
        //$('.angryman-percent').html("<span style='font-size:12px'>MAX LOTS(" + maxlots + ")</span> " + angryman.toFixed(0) + "%");

        var talk_result = "";
        if (angryman == 0) talk_result = "RobotFX is standby to open trade and scanning for opportunity.";
        if (angryman > 0) talk_result = "RobotFX's GBPUSD trade appears to be performing well, and I'm feeling very positive.";
        if (angryman > 10) talk_result = "The GBPUSD trade executed by RobotFX seems to be in good shape.";
        if (angryman > 20) talk_result = "I am pleased to report that the GBPUSD trade executed by RobotFX is ok, and I am actively working on closing it to lock in profits.";
        if (angryman > 30) talk_result = "Today's market conditions have made RobotFX's GBPUSD trade a bit challenging, but I'm confident in my ability to handle it.";
        if (angryman > 50) talk_result = "RobotFX's GBPUSD trade is looking tough today, but I'm working hard to navigate the situation.";
        $('.robottalk').html("\n        <span class=\"badge color-blue\">FxBot Opinion</span>\n        <br/><br/>" + talk_result + "\n        "); //CheckFinancial later after get the CurrencyConversion

        checkFinancial();
      }
    });
  };

  var checkChart = function checkChart() {
    if (localStorage.getItem('AccountNumber') == null) {
      return;
    }

    $f7.request({
      method: 'get',
      url: window.path + 'static/api/tradeV2.php?action=get_chart&AccountNumber=' + localStorage.getItem('AccountNumber'),
      success: function success(dataTrade) {
        $f7.preloader.hide();
        console.log("Output Chart:" + dataTrade);
        dataTrade = JSON.parse(dataTrade);
        var dataset = [0];
        var datasetOrigin = [0];
        var datasetBroker = [0];
        var labels = [" "];
        var profit = 0;
        var profit_today = 0;

        if (dataTrade[0].OrderProfit != null) {
          var orderCount = 0;

          for (var i = 0; i < dataTrade.length; i++) {
            profit = profit + parseFloat(dataTrade[i].OrderProfit);
            orderCount = parseInt(dataTrade[i].Count);
            var theDate = dataTrade[i].DateTime.substring(0, 10);
            dataset.push(profit.toFixed(2));
            datasetBroker.push((profit * 0.3).toFixed(2));
            datasetOrigin.push(0);
            var dateArray = theDate.split('-');
            labels.push(dateArray[0] + "/" + dateArray[1]);
          }

          $(".OrderCount").html(orderCount);
          $(".profit-info").html(" - (NET)$" + profit.toFixed(2));
          $(".AccountProfit").html("US$" + profit.toFixed(2));
          $(".AccountProfitMyr").html("MYR$" + (profit * window.rate).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,'));
        }

        var ctx = document.getElementById('myChart').getContext('2d');
        var gradient = ctx.createLinearGradient(0, 0, 0, 400);
        gradient.addColorStop(0, 'rgba(98, 204, 126,0.5)');
        gradient.addColorStop(1, 'rgba(0,0, 0,0)');
        var gradient2 = ctx.createLinearGradient(0, 0, 0, 400);
        gradient2.addColorStop(0, 'rgba(256, 0, 0,0.5)');
        gradient2.addColorStop(1, 'rgba(0,0, 0,0)');
        var gradient3 = ctx.createLinearGradient(0, 0, 0, 400);
        gradient3.addColorStop(0, 'rgba(255, 168, 94,0.5)');
        gradient3.addColorStop(1, 'rgba(0,0, 0,0)');
        var data = {
          labels: labels,
          datasets: [{
            label: 'Total',
            data: dataset,
            fill: 'start',
            backgroundColor: gradient,
            borderColor: 'rgb(98, 204, 126)',
            tension: 0,
            borderWidth: 1,
            pointStyle: 'circle',
            pointRadius: 0
          }, {
            label: 'RobotFx',
            data: datasetBroker,
            fill: 'start',
            backgroundColor: gradient3,
            borderColor: 'rgb(255, 168, 94)',
            tension: 0,
            pointStyle: 'circle',
            borderWidth: 1,
            pointRadius: 0
          }, {
            label: 'Baseline',
            data: datasetOrigin,
            fill: 'start',
            backgroundColor: gradient2,
            borderColor: 'rgb(255, 0, 0)',
            tension: 0,
            pointStyle: 'circle',
            borderWidth: 1,
            pointRadius: 0,
            borderDash: [5, 5]
          }]
        }; //console.log(window.theChart);

        if (window.theChart == undefined) window.theChart = new Chart(ctx, {
          type: 'line',
          data: data,
          options: {
            animation: {
              duration: 0
            },
            plugins: {
              legend: {
                display: true
              }
            },
            scales: {
              y: {
                beginAtZero: true,
                grid: {
                  color: '#222'
                }
              },
              x: {
                grid: {
                  color: '#222'
                }
              }
            }
          }
        });
        window.theChart.data = data;
        window.theChart.update();
      }
    });
  };

  var checkChartDaily = function checkChartDaily() {
    if (localStorage.getItem('AccountNumber') == null) {
      return;
    }

    $f7.request({
      method: 'get',
      url: window.path + 'static/api/tradeV2.php?action=get_chart&AccountNumber=' + localStorage.getItem('AccountNumber'),
      success: function success(dataTrade) {
        $f7.preloader.hide(); //console.log("Output Chart:" + dataTrade);

        dataTrade = JSON.parse(dataTrade);
        var dataset = [0];
        var datasetOrigin = [0];
        var datasetToday = [0];
        var labels = [" "];
        var profit = 0;
        var profit_today = 0;

        if (dataTrade[0].OrderProfit != null) {
          var theDate = "";
          var orderCount = "";

          for (var i = 0; i < dataTrade.length; i++) {
            profit = profit + parseFloat(dataTrade[i].OrderProfit);
            profit_today = parseInt(parseFloat(dataTrade[i].OrderProfit));
            orderCount = dataTrade[i].Count;
            theDate = dataTrade[i].DateTime.substring(0, 10);
            datasetToday.push(profit_today.toFixed(2));
            datasetOrigin.push(0);
            var dateArray = theDate.split('-');
            labels.push(dateArray[0] + "/" + dateArray[1]);
          }

          $(".OrderCount").html(orderCount);
          $(".profit-info").html(" - (NET)$" + profit.toFixed(2));
          $(".AccountProfit").html("US$" + profit.toFixed(2));
        }

        var ctx = document.getElementById('myChartDaily').getContext('2d');
        var gradient = ctx.createLinearGradient(0, 0, 0, 400);
        gradient.addColorStop(0, 'rgba(98, 204, 126,0.5)');
        gradient.addColorStop(1, 'rgba(0,0, 0,0)');
        var gradient2 = ctx.createLinearGradient(0, 0, 0, 400);
        gradient2.addColorStop(0, 'rgba(256, 0, 0,0.5)');
        gradient2.addColorStop(1, 'rgba(0,0, 0,0)');
        var gradient3 = ctx.createLinearGradient(0, 0, 0, 400);
        gradient3.addColorStop(0, 'rgba(94, 168, 255,0.5)');
        gradient3.addColorStop(1, 'rgba(0,0, 0,0)');
        var data = {
          labels: labels,
          datasets: [{
            label: 'Daily Profit',
            data: datasetToday,
            fill: 'start',
            backgroundColor: gradient3,
            borderColor: 'rgb(94, 168, 255)',
            tension: 0,
            pointStyle: 'circle',
            borderWidth: 1,
            pointRadius: 0
          }, {
            label: 'Baseline',
            data: datasetOrigin,
            fill: 'start',
            backgroundColor: gradient2,
            borderColor: 'rgb(255, 0, 0)',
            tension: 0,
            pointStyle: 'circle',
            borderWidth: 1,
            pointRadius: 0,
            borderDash: [5, 5]
          }]
        }; //console.log(window.theChart);

        if (window.theChartDaily == undefined) window.theChartDaily = new Chart(ctx, {
          type: 'line',
          data: data,
          options: {
            animation: {
              duration: 0
            },
            plugins: {
              legend: {
                display: true
              }
            },
            scales: {
              y: {
                beginAtZero: true,
                grid: {
                  color: '#222'
                }
              },
              x: {
                grid: {
                  color: '#222'
                }
              }
            }
          }
        });
        window.theChartDaily.data = data;
        window.theChartDaily.update();
      }
    });
  };

  var checkChartRadar = function checkChartRadar() {
    $f7.request({
      method: 'get',
      url: window.path + 'static/api/tradeV2.php?action=get_chart&AccountNumber=' + localStorage.getItem('AccountNumber'),
      success: function success(dataTrade) {
        dataTrade = JSON.parse(dataTrade);
        var dataset = [];
        var labels = [];
        var ProfitGross = 0;
        var ProfitNet = 0;
        var ProfitOwner = 0;
        var ProfitBroker = 0;
        var Lose = 0;
        if (dataTrade[0].OrderProfit == null) return;

        for (var i = 0; i < dataTrade.length; i++) {
          var amount = parseFloat(dataTrade[i].OrderProfit);

          if (amount > 0) {
            ProfitGross += amount;
            ProfitNet += amount;
          } else {
            ProfitNet += amount;
            Lose += amount;
          }
        } //console.log("Amount:" + Lose);


        ProfitBroker = ProfitNet * 0.3;
        ProfitOwner = ProfitNet * 0.7;
        dataset.push(ProfitNet);
        labels.push("Net Profit");
        dataset.push(ProfitOwner);
        labels.push("Owner");
        dataset.push(ProfitBroker);
        labels.push("Broker");
        var ctx = document.getElementById('myChartRadar').getContext('2d');
        var gradient = ctx.createLinearGradient(0, 0, 0, 400);
        gradient.addColorStop(0, 'rgba(98, 204, 126,0.5)');
        gradient.addColorStop(1, 'rgba(0,0, 0,0)');
        var data = {
          labels: labels,
          datasets: [{
            label: 'Profit',
            data: dataset,
            backgroundColor: gradient,
            borderWidth: 1,
            borderColor: 'rgb(98, 204, 126)',
            tension: 0
          }]
        };
        console.log(data);
        if (window.theChartRadar == undefined) window.theChartRadar = new Chart(ctx, {
          type: 'radar',
          data: data,
          responsive: true,
          options: {
            animation: {
              duration: 0
            },
            plugins: {
              legend: {
                display: false
              }
            },
            scales: {
              r: {
                beginAtZero: true,
                grid: {
                  borderColor: 'gray',
                  color: '#444444'
                },
                angleLines: {
                  color: 'gray'
                },
                ticks: {
                  display: false
                },
                pointLabels: {
                  color: 'white'
                }
              }
            }
          }
        });
        window.theChartRadar.data = data;
        window.theChartRadar.update();
      }
    });
  };

  $on('pageInit', function () {
    // do something on page init
    var app = $f7;
    $(".control").hide();

    if (window.mobileCheck()) {
      var myCanvas1 = document.getElementById('myChart');
      myCanvas1.height = 300;
      var myCanvas2 = document.getElementById('myChartRadar');
      myCanvas2.height = 300;
      var myCanvas3 = document.getElementById('myChartDaily');
      myCanvas3.height = 300;
    }

    var monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    var d = new Date();
    month = monthNames[d.getMonth()];
    day = d.getDate();
    $update();

    if (localStorage.getItem("AccountNumber")) {
      checkInfo();
      checkChart();
      checkChartDaily();
      checkChartRadar();
    }

    window.control = localStorage.getItem("control");
    setInterval(function () {
      if (localStorage.getItem("AccountNumber")) {
        checkInfo();
        checkChartRadar();
        checkChart();
        checkChartDaily();
      }
    }, 60000);
    setInterval(function () {
      if (localStorage.getItem("AccountNumber")) if (window.checkNow == true) {
        window.checkNow = false;
        checkInfo(); //checkChartRadar();

        checkChart();
        checkChartDaily();
      }
    }, 100);
    setInterval(function () {
      if (window.control != true) $(".control").hide();else $(".control").show();
    }, 100);
  });
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
  <div class="page" data-name="home">
     
     <!-- Top Navbar -->
     <div class="navbar navbar-transparent no-hairline">
      <div class="navbar-bg"></div>
      <div class="navbar-inner">
        <!-- <div class="left">
          <a href="#" class="link icon-only panel-open" data-panel="left">
            <i class="icon f7-icons if-not-md">menu</i>
            <i class="icon material-icons if-md">menu</i>
          </a>
        </div> -->
        <div class="left"><img src="static/images/RobotFX6.png" width="150px"/></div>
        
        <!-- <div class="title-large">
          <div class="title-large-text"><img src="static/images/RobotFX6.png" width="150px"/></div>
          
        </div> -->
      </div>
    </div>

    <!-- Scrollable page content-->
    <div class="page-content"  style="background: linear-gradient(180deg, #121212 0%, #000000 100%);">
      <div class="wrap">

        <!-- <div class="card" style="border-radius: 10px;background-color: #151924;">
          <div class="card-content card-content-padding">
            <table width="100%">
              <td><span style="color:darkgray">Account Holder</span></td>
              <td style="text-align: right;"><span style="color:darkgray">Investment Value</span></td>
            </table>

            <table width="100%">
              <td><span class="DisplayName">Guest</span>
                <BR/><span style="color:darkgray"><span class="AccountName"></span> (<span class="AccountLots"></span>)</span>
              </td>
              <td style="text-align: right;" >
                <span style="font-size: 18px;" class="AccountBalanceOwn"> $0.00 </span>
                <br/>
                <span style="font-size:14px;color:gray" class="balance-myr"></span>
              </td>
              
            </table>
    
          </div>
        </div> -->

        <!-- <div class="card card-login" style="border-radius: 10px;">
          <div class="card-content card-content-padding">
            <table width="100%" style="text-align: center;">
              <td width="100%">
                <div @click="${openAccount}">
                  <p>
                    <i class="icon f7-icons">person_badge_plus</i>
                  </p>
                  <span style="color:darkgray">Create Account</span>
                </div> 
              </td>
            </table>
          </div>
        </div> -->

        
        <div class="one">
          <div class="list block no-hairlines" style="margin-top: 15px;">
            <ul style="border-radius: 10px;background-color: #151924;">          
            <li>
              <div class="item-content">
                <div class="item-inner">
                  <div class="item-title"><span style="font-size: 15px;">Account Stock</span></div>
                  <div class="item-after"><span style="color:darkgray;font-size: 12px;">PRICE</span></div>
                </div>
              </div>
            </li>
              <li>
                <div class="item-content">
                  <div class="item-media">
                    <img src="static/images/candlestick.png" width="40px"/>
                  </div>
                  <div class="item-inner">
                    <div class="item-title"><B><span class="AccountName"></span></B><BR/><span class="AccountNumber" style="color:darkgray;font-size: 12px;"></span> <span style="color:darkgray;font-size: 12px;"> (1 LOT)</span></div>
                    <div class="item-after"><span style="color:greenyellow;font-size: 18px;" class="AccountMarketPrice"></span></div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
  
          <div class="list block no-hairlines" style="margin-top: -20px;">
            <ul style="border-radius: 10px;background-color: #151924;">          
            <li>
              <div class="item-content">
                <div class="item-inner">
                  <div class="item-title"><span style="font-size: 15px;">Stock Trading Pair</span></div>
                  <div class="item-after"><span style="color:darkgray;font-size: 12px;">OCTAFX</span></div>
                </div>
              </div>
            </li>
              <li>
                <div class="item-content">
                  <div class="item-media">
                    <img src="static/images/forex.png" width="40px"/>
                  </div>
                  <div class="item-inner">
                    <div class="item-title"><B>GBPUSD</B><br/><span style="color:darkgray;font-size: 12px;">Great Britain/US Dollar</span></div>
                    <div class="item-after"><span style="color:greenyellow;font-size: 18px;" class="price"></span></div>
                  </div>
                </div>
              </li>
              
              <li>
                <div class="item-content">
                  <div class="item-inner">
                    <div class="item-after"><span style="color:darkgray;font-size: smaller;" class="last_refresh"></span></div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
  
          <div class="list block no-hairlines" style="margin-top: -20px;">
            <ul style="border-radius: 10px;background-color: #151924;">   
              <li>
                <div class="item-content">
                  <div class="item-inner">
                    <div class="item-title"><span style="font-size: 15px;">Robot Trading</span></div>
                    <div class="item-after"><span style="color:darkgray;font-size: 12px;">LIVE</span></div>
                  </div>
                </div>
              </li>
              <span class="progressbar-infinite"></span>
              <li class="" style="display:none;">
                <div class="item-content">
                  <div class="item-inner">
                    <div class="item-header">Order Type</div>
                    <div class="item-after"><span class="OrderType"></span></div>
                  </div>
                </div>
              </li> 
              <li style="display:none;">
                <div class="item-content">
                  <div class="item-inner">
                    <div class="item-header">Order Price</div>
                    <div class="item-after"><span class="OrderPrice"></span></div>
                  </div>
                </div>
              </li>
              <li>
                <div class="item-content">
                  <div class="item-inner">
                    <div class="item-header">Total Balance <br/> <span style="font-size:14px;color:gray" class="AccountBalanceMyr"></span></div>
                    <div class="item-after"><span class="AccountBalance"></span>
                    </div>
                  </div>
                </div>
              </li>
              <li>
                <div class="item-content">
                  <div class="item-inner">
                    <div class="item-header">Total Profit <br/> <span style="font-size:14px;color:gray" class="AccountProfitMyr"></span></div>
                    <div class="item-after"><span style="color:rgb(101, 132, 255);font-size: 18px;" class="AccountProfit"></span></div>
                  </div>
                </div>
              </li> 
              <li>
                <div class="item-content">
                  <div class="item-inner">
                    <div class="item-header">Currency Conversion  <br/> <span style="font-size:14px;color:gray">USDMYR</span></div>
                    <div class="item-after"><span class="CurrencyConversion"></span>
                    </div>
                  </div>
                </div>
              </li>
              <li >
                <div class="item-content">
                  <div class="item-inner">
                    <div class="item-header">Margin Usage</div>
                    <div class="item-after"><span class="AccountMargin"></span></div>
                  </div>
                </div>
              </li>
              <li style="display: none;">
                <div class="item-content">
                  <div class="item-inner">
                    <div class="item-header">Free Margin</div>
                    <div class="item-after"><span class="AccountFreeMargin"></span></div>
                  </div>
                </div>
              </li>
              <li>
                <div class="item-content">
                  <div class="item-inner">
                    <div class="item-header">Order Lots</div>
                    <div class="item-after"><span style="color:greenyellow;font-size: 18px;" class="OrderLots"></span></div>
                  </div>
                </div>
              </li> 
              <li class="control">
                <div class="item-content">
                  <div class="item-inner">
                    <div class="item-title"><span style="font-size: 15px;">Heat Level</span></div>
                    <div class="item-after"><span class="angryman-percent"></span></div>
                  </div>
                </div>
              </li>   
              <span class="progressbar angryman color-red control" data-progress="0" style="height:5px;border-radius: 0px;"></span>
              <li style="display: none;">
                <div class="item-content">
                  <div class="item-inner">
                    <div class="item-header">Floating Pip</div>
                    <div class="item-after"><span style="color:greenyellow;font-size: 18px;" class="Pip"></span></div>
                  </div>
                </div>
              </li>
              <li class="control">
                <div class="item-content">
                  <div class="item-inner">
                    <div class="item-header">Floating Profit</div>
                    <div class="item-after"><span class="OrderProfit"></span></div>
                  </div>
                </div>
              </li>
            </ul>
          </div>

          <div class="card" style="border-radius: 10px; margin-top: -20px; margin-bottom:35px;background-color: #151924;">
            <div class="card-content card-content-padding">
              <table width="100%">
                <td width="10%">
                  <img src="static/images/Robot2.png" width="100%"/>
                </td>
                <td width="90%" style="vertical-align: middle; color:antiquewhite;font-size: smaller;" class="robottalk">
                </td>
              </table>
            </div>
            <div class="card-footer">FxBot opinion based on live trade</div>
          </div>

        </div>

        <div class="two">
          <div class="card" style="border-radius: 10px; margin-top: -20px;background-color: rgba(0, 0, 0, 0);">
            <div class="card-content card-content-padding">
              Robot Live Total
              <br/>
              <span style="color:darkgray;font-size: 12px;"><span class="OrderCount">0</span> Orders<span class="profit-info">0</span></span>
            <canvas id="myChart" width="400" height="210"></canvas>
            </div>
          </div>
  
  
          <div class="card" style="border-radius: 10px; margin-top: 0px;background-color: rgba(0, 0, 0, 0);">
            <div class="card-content card-content-padding">
              Robot Live Daily
              <br/>
              <span style="color:darkgray;font-size: 12px;"><span class="OrderCount">0</span> Orders<span class="profit-info">0</span></span>
            <canvas id="myChartDaily" width="400" height="210"></canvas>
            </div>
          </div>
  
          <div class="card" style="border-radius: 10px; margin-top: 0px;background-color: rgba(0, 0, 0, 0);">
            <div class="card-content card-content-padding">
              Robot Radar
              <br/>
              <span style="color:darkgray;font-size: 12px;"><span class="RadarAI"></span></span>
            <canvas id="myChartRadar" width="400" height="210"></canvas>
            </div>
          </div>
        </div>



      </div>
      
      <div class="block" style="border-radius: 10px; margin-top: -20px;">
        <!-- TradingView Widget BEGIN -->
        <div class="tradingview-widget-container">
          <div id="tradingview_2f7b8"></div>
          <script type="text/javascript" src="https://s3.tradingview.com/tv.js"></script>
          <script type="text/javascript">
            window.onload = function(e){ 
              new TradingView.widget(
              {
              "width": "100%",
              "height": 300,
              "symbol": "OANDA:GBPUSD",
              "interval": "D",
              "timezone": "Asia/Singapore",
              "theme": "dark",
              "style": "1",
              "locale": "en",
              "toolbar_bg": "#000000",
              "hide_legend": true,
              "enable_publishing": false,
              "allow_symbol_change": false,
              "backgroundColor":"#000000",
              "container_id": "tradingview_2f7b8"
              }
              );
            };

              

          </script>
        </div>
        <!-- TradingView Widget END -->
      </div>



      <div class="card control" style="border-radius: 10px;background-color: #151924;">
        <div class="card-content card-content-padding">
          <table width="100%">
            <td><span style="color:darkgray">Aux Controller</span></td>
            <td style="text-align: right;"><span style="color:darkgray"></span></td>
          </table>
          
          <table width="100%" style="text-align: center;">
            <!-- <td width="25%">
              <div @click="${()=>angryFlush('1')}">
                <p>
                  <i class="icon f7-icons">plus_circle</i>
                </p>
                <span style="color:darkgray">Buy</span>
              </div> 
            </td> -->
            <!-- <td width="25%">
              <div @click="${()=>angryFlush('2')}">
              <p>
                <i class="icon f7-icons">minus_circle</i>
              </p>
              <span style="color:darkgray">Sell</span>
              </div>
            </td> -->
            <td width="25%">
              <div @click="${()=>angryFlush('3')}">
              <p>
                <i class="icon f7-icons">stop_circle</i>
              </p>
              <span style="color:darkgray">Stop</span>
              </div>
            </td>
            <td width="25%">
              <div @click="${()=>angryFlush('4')}">
              <p>
                <i class="icon f7-icons">play_circle</i>
              </p>
              <span style="color:darkgray">Continue</span>
              </div>
            </td>
            <!-- <td width="33%">
              <p>
                <i class="icon f7-icons">arrow_right_arrow_left_circle</i>
              </p>
              <span style="color:darkgray">Transaction</span>
            </td> -->
          </table>
        </div>
      </div>

    </div>
  </div>
`
    }
    ;
}

framework7Component.id = 'a69cfcbb1a';
export default framework7Component;